import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { PlainModal } from '@client/new/components/Modal/Modal';
import { Typography } from '@design-system/components/typography/typography';
import { UploadItem } from '../components/UploadItem';
import { SlideUpload } from './slides.viewModel';
import { Col, Row } from '@design-system/components/grid/grid';
import { DropZone } from '@design-system/components/dropZone/dropZone';
import SuperTooltip from '@client/new/components/SuperTooltip/SuperTooltip';

type PDFModalProps = {
  uploads: SlideUpload[];
  onChange: (file: File[]) => void;
  onCancel: (fileName: string) => void;
  onRetry: (fileName: string) => void;
  isOpen: boolean;
  onClose: () => void;
};

export const SlidesModal = (p: PDFModalProps) => (
  <PlainModal
    isOpen={p.isOpen}
    onClose={p.onClose}
    height="auto"
    sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: '24px',
      padding: '0px',
      maxWidth: '740px',
      minHeight: '320px',
      overflow: 'auto',
    }}
  >
    <div
      data-testid="slides-upload-modal"
      style={{
        padding: 24,
        display: 'flex',
        gap: 24,
        flexDirection: 'column',
      }}
    >
      <div className="flex justify-between">
        <Row alignCenter>
          <Typography variant="headline">Upload Slides</Typography>
          <SuperTooltip templateId="extras-slides" />
        </Row>
        <div className="cursor-pointer" onClick={p.onClose} role="button">
          <FontAwesomeIcon
            icon={faTimes}
            className="ml-3 leading-none text-sm w-[28px] h-[28px] self-center"
          />
        </div>
      </div>

      {p.uploads.length === 0 ? (
        <Typography>
          Upload images. Minimum image dimensions: 1125 x 2436px
        </Typography>
      ) : (
        <Row>
          <Col>
            <Typography>
              Uploading {p.uploads.length} file(s). Do not close browser tab!
              <br /> Edit mode will open automatically once the upload is
              complete.
            </Typography>
          </Col>
          <Col style={{ textAlign: 'right' }}>
            <Typography>
              {p.uploads.filter((u) => u.status === 'done').length} out of{' '}
              {p.uploads.length} completed.
            </Typography>
          </Col>
        </Row>
      )}

      <div style={{ gap: 24, flexDirection: 'column', display: 'flex' }}>
        <DropZone
          className="h-[170px] text-center"
          multiple
          accept={['image/png', 'image/jpeg', 'image/jpg']}
          onChange={p.onChange}
        />
        {p.uploads.map((upload) => (
          <UploadItem
            key={upload.file.name}
            name={upload.file.name}
            onCancel={() => p.onCancel(upload.id)}
            onRetry={() => p.onRetry(upload.id)}
            thumbnailURL={URL.createObjectURL(upload.file)}
            progressValue={upload.progress}
            error={upload.status === 'error'}
          />
        ))}
      </div>
    </div>
  </PlainModal>
);
